document.addEventListener('DOMContentLoaded', (event) => {
  var today = new Date();

  //Mother's Day Sale April 24 - EOD May 1
  var mdayStart = new Date(Date.UTC(2025,3,24,5,0,0));
  var mdayEnd = new Date(Date.UTC(2025,4,2,4,59,0));

  //Post Mother's Day May 2 - May 12
  var postMDayEnd = new Date(Date.UTC(2025,4,13,4,59,0));

  //National Smile Day May 31st
  var smileDayStart = new Date(Date.UTC(2025,4,31,4,59,0));
  var smileDayEnd = new Date(Date.UTC(2025,5,1,4,59,0));

  //7th Birthday July 13-19
  var birthdayStart = new Date(Date.UTC(2025,6,13,5,0,0));
  var birthdayEnd = new Date(Date.UTC(2025,6,20,4,59,0));


  if ( document.querySelector('.promo__wrapper') !== null ) {
    //promos
    if ( today >= mdayStart && today < mdayEnd ) {
      document.querySelectorAll('.promo__wrapper.mday2025').forEach((elem) => {
        if(!elem.classList.contains('noCart')) {
          elem.style.display = 'flex';
        }
      })
    } else if ( today >= mdayEnd && today <= postMDayEnd ) {
      document.querySelectorAll('.promo__wrapper.postMDay2025').forEach((elem) => {
        if(!elem.classList.contains('noCart')) {
          elem.style.display = 'flex';
        }
      })
    } else if ( today > smileDayStart && today < smileDayEnd ) {
      document.querySelectorAll('.promo__wrapper.smileDay2025').forEach((elem) => {
        if(!elem.classList.contains('noCart')) {
          elem.style.display = 'flex';
        }
      })
    } else if ( today >= birthdayStart && today <= birthdayEnd ) {
      document.querySelectorAll('.promo__wrapper.birthday2025').forEach((elem) => {
        if(!elem.classList.contains('noCart')) {
          elem.style.display = 'flex';
        }
      })
    }
  }

  /*var christmasLightsStart = new Date(Date.UTC(2024,11,1,6,0,0));
  var christmasLightsEnd = new Date(Date.UTC(2024,11,26,5,59,0));

  if ( document.querySelector('.holiday-banner') && today >= christmasLightsStart && today <= christmasLightsEnd ) {
    document.querySelector('.holiday-banner').style.display = "block";
  }*/
  
});